import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { clearPendingOrders, getPendingOrders } from '../../../actions/transferActions'
import { seeWineries } from '../../../actions/wineryActions'
import TransferHistoryView from '../../../containers/Inventory/transfer/TransferHistoryView'

const TransferHistory = () => {
    const dispatch = useDispatch()
    const [winery, setWinery] = useState(null)
    const { pendingOrders } = useSelector(state => state.tranfers)
    const { wineriesList } = useSelector((state) => state.wineriesAdmin);
    const [orderType, setOrderType] = useState("catering")
    useEffect(() => {
        dispatch(seeWineries());
    
      return () => {
        
      }
    }, [])
    
    useEffect(() => {
        if (orderType) {
            dispatch(getPendingOrders( 4,orderType))
        }
        return () => [
            dispatch(clearPendingOrders())
        ]
    }, [orderType])
    const transfers =[
        {date:"20/01/2021",type:"Transferencia",origin:"Bodega 1",destiny:"Almacen 1",_id:"544312"},
        {date:"20/01/2021",type:"Transferencia",origin:"Bodega 1",destiny:"Almacen 1",_id:"544312"},
        {date:"20/01/2021",type:"Transferencia",origin:"Bodega 1",destiny:"Almacen 1",_id:"544312"},
        {date:"20/01/2021",type:"Transferencia",origin:"Bodega 1",destiny:"Almacen 1",_id:"544312"},
        {date:"20/01/2021",type:"Transferencia",origin:"Bodega 1",destiny:"Almacen 1",_id:"544312"},
    ]
    return (
       <TransferHistoryView transfers={pendingOrders}  orderType ={orderType} setOrderType ={setOrderType} />
    )
}

export default TransferHistory
